import { render, staticRenderFns } from "./PedidosProveedoresList.vue?vue&type=template&id=402e2312&scoped=true&"
import script from "./PedidosProveedoresList.vue?vue&type=script&lang=js&"
export * from "./PedidosProveedoresList.vue?vue&type=script&lang=js&"
import style0 from "./PedidosProveedoresList.vue?vue&type=style&index=0&id=402e2312&lang=scss&scoped=true&"
import style1 from "./PedidosProveedoresList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402e2312",
  null
  
)

export default component.exports